module.exports = __webpack_public_path__ + "img/menucn_4_5.9fd4af5d.svg";